module.exports = __webpack_public_path__ + "img/2_49.63972eea.png";